/* @ngInject */
function PhotoFactory($http) {
  class Photo {
    constructor(data) {
      if (data) angular.extend(this, data);
    }

    static getListPhotosResourceUrl() {
      return `${process.env.SERVER_URL}/api/secure/photos/list`;
    }

    static getSearchPhotosResourceUrl() {
      return `${process.env.SERVER_URL}/api/secure/photos/search`;
    }

    static listPhotos(params) {
      return $http
        .get(Photo.getListPhotosResourceUrl(), { params })
        .then((response) =>
          response.data.map((photoData) => new Photo(photoData))
        );
    }

    static searchPhotos(params) {
      return $http
        .get(Photo.getSearchPhotosResourceUrl(), { params })
        .then((response) =>
          response.data.map((photoData) => new Photo(photoData))
        );
    }

    static downloadLocationPhoto(downloadLocation) {
      return $http
        .get(downloadLocation, {
          params: { client_id: process.env.UNSPLASH_ACCESS_KEY },
        })
        .then(() => true);
    }
  }

  return Photo;
}

export default PhotoFactory;
